import './Welcome.css';
import Footer from '../pages/Footer.js'
import React from "react";


function About() {
    return (
        <div className="">
            <div className="welcomeDivText">
                    <p className="four"> welcome to </p>
                    <p className="eight"> one of fourteen </p>
            </div>
            <p className="eight"> video coming soon </p>
            <Footer />
        </div>
    )
}

export default About;